import { EAcquisitionType } from "@constants";
import { keycloakUtils } from "itsf-ui-common";

export const getAcquisitionType = () =>
    keycloakUtils.isAuthenticated() ? EAcquisitionType.CROSS_SELL : EAcquisitionType.NEW_ACQUISITION;
